// Events Module
export var EventNotificationType;
(function (EventNotificationType) {
    EventNotificationType["EventCreated"] = "EventCreated";
    EventNotificationType["EventDeadline"] = "EventDeadline";
    EventNotificationType["EventRescheduled"] = "EventRescheduled";
    EventNotificationType["VehicleDriverNumberMissing"] = "VehicleDriverNumberMissing";
})(EventNotificationType || (EventNotificationType = {}));
// Tasks Module
export var TaskNotificationType;
(function (TaskNotificationType) {
    TaskNotificationType["TaskAssigned"] = "TaskAssigned";
    TaskNotificationType["TaskDeadlineApproaching"] = "TaskDeadlineApproaching";
    TaskNotificationType["TaskCompleted"] = "TaskCompleted";
})(TaskNotificationType || (TaskNotificationType = {}));
// Activities Module
export var ActivityNotificationType;
(function (ActivityNotificationType) {
    ActivityNotificationType["BirthdayCelebration"] = "BirthdayCelebration";
    ActivityNotificationType["WorkAnniversary"] = "WorkAnniversary";
    ActivityNotificationType["WeddingAnniversary"] = "WeddingAnniversary";
    ActivityNotificationType["BirthAdoption"] = "BirthAdoption";
    ActivityNotificationType["Retirement"] = "Retirement";
    ActivityNotificationType["MarriageRegistration"] = "MarriageRegistration";
    ActivityNotificationType["EmployeeOnboarding"] = "EmployeeOnboarding";
    ActivityNotificationType["EmployeeDeparture"] = "EmployeeDeparture";
    ActivityNotificationType["EmployeeDeath"] = "EmployeeDeath";
    ActivityNotificationType["EmployeeIllness"] = "EmployeeIllness";
    ActivityNotificationType["CompanyAnniversary"] = "CompanyAnniversary";
})(ActivityNotificationType || (ActivityNotificationType = {}));
export const NotificationTypeDisplay = {
    // Events
    [EventNotificationType.EventCreated]: 'Event Assignment',
    [EventNotificationType.EventDeadline]: 'Event Deadline',
    [EventNotificationType.EventRescheduled]: 'Event Rescheduled',
    // Tasks
    [TaskNotificationType.TaskAssigned]: 'Task Assigned',
    [TaskNotificationType.TaskDeadlineApproaching]: 'Task Deadline Approaching',
    [TaskNotificationType.TaskCompleted]: 'Task Completed',
    // Activities
    [ActivityNotificationType.BirthdayCelebration]: 'Birthday Celebration',
    [ActivityNotificationType.WorkAnniversary]: 'Work Anniversary',
    [ActivityNotificationType.WeddingAnniversary]: 'Wedding Anniversary',
    // Backward compatibility: map legacy MarriageAnniversary to Wedding Anniversary
    MarriageAnniversary: 'Wedding Anniversary',
    [ActivityNotificationType.BirthAdoption]: 'Birth/Adoption',
    [ActivityNotificationType.Retirement]: 'Retirement',
    [ActivityNotificationType.MarriageRegistration]: 'Marriage Registration',
    [ActivityNotificationType.EmployeeOnboarding]: 'Employee Onboarding',
    [ActivityNotificationType.EmployeeDeparture]: 'Employee Departure',
    [ActivityNotificationType.EmployeeDeath]: 'Employee Death',
    [ActivityNotificationType.EmployeeIllness]: 'Employee Illness',
    [ActivityNotificationType.CompanyAnniversary]: 'Company Anniversary',
    [EventNotificationType.VehicleDriverNumberMissing]: 'Vehicle Driver Number Missing'
};
